import React from "react";
import { defaultDeliveryInvoice } from "../data/deliveryInvoiceConfig";

const DeliveryTemplate = ({ data = {} }) => {

  const invoice = {
    company: { ...defaultDeliveryInvoice.company, ...(data.company || {}) },
    invoice: { ...defaultDeliveryInvoice.invoice, ...(data.invoice || {}) },
    client: { ...defaultDeliveryInvoice.client, ...(data.client || {}) },
    items: data.items || defaultDeliveryInvoice.items,
    summary: { ...defaultDeliveryInvoice.summary, ...(data.summary || {}) }
  };

  const primaryBlue = "bg-[#2563EB]";
  const textBlue = "text-[#2563EB]";

  return (
    <div
      id="delivery-invoice"
      className="bg-white px-8 py-6 text-gray-800 font-sans mx-auto text-[12px] leading-tight"
    >

      <div className="flex justify-between items-start mb-6">
        <div className="w-16 h-16 flex items-center justify-center">
          {!invoice.company.logo ? (
            <img
              src='./logo1.png'
              alt="Company Logo"
              className="object-contain w-full h-full"
            />
          ) : (
            <div
              className={`w-16 h-16 rounded-full ${primaryBlue} flex items-center justify-center text-white text-2xl font-bold`}
            >
              {invoice.company.logoText}
            </div>
          )}
        </div>

        <div className="text-right">
          <h2 className={`font-bold text-base ${textBlue}`}>{invoice.company.name}</h2>
          <p className="text-[11px] text-gray-500">
            {invoice.company.address}<br />
            GSTIN: {invoice.company.gstin}<br />
            {invoice.company.phone} | {invoice.company.email}
          </p>
        </div>
      </div>

      <h1 className={`text-center text-lg font-light tracking-widest ${textBlue} uppercase mb-4`}>
        Delivery Invoice
      </h1>

      <div className="flex justify-between mb-5">
        <div className="space-y-3 text-[11px]">
          <div>
            <p className="font-bold text-gray-400">Bill To</p>
            <p className="font-bold">{invoice.client.name}</p>
            <p className="text-gray-500 max-w-[220px]">{invoice.client.address}</p>
            <p className="text-gray-500">GSTIN: {invoice.client.gstin}</p>
          </div>
          <div>
            <p className="font-bold text-gray-400">Ship To</p>
            <p className="font-bold">{invoice.client.name}</p>
            <p className="text-gray-500 max-w-[220px]">{invoice.client.address}</p>
          </div>
        </div>

        <div className="w-56 border border-blue-200 text-[11px]">
          {[
            { label: "Invoice#", val: invoice.invoice.number },
            { label: "Invoice Date", val: invoice.invoice.date },
            { label: "Terms", val: invoice.invoice.terms },
            { label: "Due Date", val: invoice.invoice.dueDate }
          ].map((row, idx) => (
            <div key={idx} className="flex border-b border-blue-100 last:border-0">
              <span className={`w-1/2 px-2 py-1 text-white ${primaryBlue} font-medium`}>
                {row.label}
              </span>
              <span className="w-1/2 px-2 py-1 text-right bg-white">
                {row.val}
              </span>
            </div>
          ))}
        </div>
      </div>

      <table className="w-full border-collapse mb-4 text-[11px]">
        <thead>
          <tr className={`${primaryBlue} text-white uppercase`}>
            <th className="py-1 px-2 border-r border-white/20 w-8">#</th>
            <th className="py-1 px-2 border-r border-white/20 text-left">Item & Description</th>
            <th className="py-1 px-2 border-r border-white/20 text-right">Qty</th>
            <th className="py-1 px-2 border-r border-white/20 text-right">Rate (₹)</th>
            <th className="py-1 px-2 text-right">Amount (₹)</th>
          </tr>
        </thead>
        <tbody className="bg-gray-50/50">
          {invoice.items.map((item, idx) => (
            <tr key={idx} className="border-b border-gray-200">
              <td className="py-1 px-2 text-center text-gray-400 border-r border-gray-200">
                {idx + 1}
              </td>
              <td className="py-1 px-2 border-r border-gray-200">
                {item.desc}
              </td>
              <td className="py-1 px-2 text-right border-r border-gray-200">
                {item.qty}
                {item.unit && (
                  <div className="text-[9px] text-gray-400 uppercase">{item.unit}</div>
                )}
              </td>
              <td className="py-1 px-2 text-right border-r border-gray-200">
                ₹ {item.rate}
              </td>
              <td className="py-1 px-2 text-right font-medium">
                ₹ {item.amount}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-end mb-5">
        <div className="w-56 text-[11px] space-y-2">
          <div className="flex justify-between text-gray-500">
            <span>Sub Total</span>
            <span>₹ {invoice.summary.subtotal}</span>
          </div>
          <div className="flex justify-between text-gray-500">
            <span>GST ({invoice.summary.gstRate}%)</span>
            <span>₹ {invoice.summary.gstAmount}</span>
          </div>
          <div className="flex justify-between font-bold pt-1 border-t border-gray-300">
            <span>Total</span>
            <span>₹ {invoice.summary.total}</span>
          </div>
          <div className={`${primaryBlue} text-white flex justify-between px-2 py-1 font-bold`}>
            <span>Balance Due</span>
            <span>₹ {invoice.summary.total}</span>
          </div>
        </div>
      </div>

      <div>
        <p className="text-[10px] text-gray-400 italic mb-2">
          Thank you for your business.
        </p>
        <div className="border-t pt-2">
          <p className="font-bold text-[10px] text-gray-600 uppercase">Terms & Conditions</p>
          <p className="text-[9px] text-gray-400">
            All payments must be made in full before commencement of services. GST as applicable.
          </p>
        </div>
      </div>

    </div>
  );
};

export default DeliveryTemplate;
